export const GetColorFromString = (value?: string | null, saturation = 60, lightness = 50): string => {
    const normalizedValue = value?.trim();

    if (!normalizedValue) return "#26a69a";
    let hash = 0;

    for (let i = 0; i < normalizedValue.length; i += 1) {
        hash = normalizedValue.charCodeAt(i) + ((hash << 5) - hash);
        hash |= 0;
    }

    const hue = Math.abs(hash) % 360;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};